<section class="cartDeliveryPayment" [ngClass]="{'cartDeliveryPayment-asm': asmMode === 'true'}">
  <section class="cartDeliveryPayment_cell cartDeliveryPayment_delivery" #cartDelivery>
    <h3 class="cartDeliveryPayment_cell_title">{{"cart.delivery.title.text" | translate}}</h3>
    <ul class="cartDeliveryPayment_cell_list">
      <li class="methodElement methodElement-{{delivery.code}}" *ngFor="let delivery of cart$ | async"
          [ngClass]="{'methodElement-selected': selectedDelivery === delivery.code,
            'methodElement-hold': ((delivery.code === deliveryMethod.pickup) && !selectedPos)
                                  || ((delivery.code === deliveryMethod.inpost || delivery.code === deliveryMethod.asmInpost) && !selectedInpost)
                                  || ((delivery.code === deliveryMethod.pocztaPolskaOrlenZabka || delivery.code === deliveryMethod.pocztaPolskaOthers) && selectedPPType !== delivery.code)
                                  || ((delivery.code === deliveryMethod.dpdPickup) && !selectedDPDPickup),
            'methodElement-disabled': deliverySubmitted}">
        <div class="engi-radio-wrapper">
          <input type="radio" name="deliveryModes" [checked]="selectedDelivery === delivery.code" id="{{delivery.code}}" [disabled]="deliverySubmitted">
          <label for="{{delivery.code}}" (click)="changeDelivery(delivery.code)">
            <figure class="methodElement_figure">
              <figcaption>{{delivery.code}}</figcaption>
            </figure>
            <p class="methodElement_description">
              <b class="methodElement_description_name">{{delivery.name}}</b>
              <span>{{delivery.description}}</span>
            </p>
            <span class="methodElement_price">
              {{delivery.price.formattedValue}}
            </span>
            <p class="methodElement_description-mobile">
              {{delivery.description}}
            </p>
          </label>
        </div>
        <ng-container *ngIf="delivery.code === deliveryMethod.pickup || delivery.code === deliveryMethod.asmPickup">
          <v-cart-poses (definePos)="setPos($event)" (definePosSelected)="setIsPosSelected($event)" [asmMode]="asmMode" [site]="site" [error]="posError" [hidden]="selectedDelivery !== deliveryMethod.pickup && selectedDelivery !== deliveryMethod.asmPickup"></v-cart-poses>
        </ng-container>
        <ng-container *ngIf="delivery.code === deliveryMethod.inpost || delivery.code === deliveryMethod.asmInpost">
          <v-cart-inpost (defineInpost)="setInpost($event)" [widget]="runInpost" [api-key]="apiKey" [error]="inpostError" [hidden]="selectedDelivery !== deliveryMethod.inpost && selectedDelivery !== deliveryMethod.asmInpost"></v-cart-inpost>
        </ng-container>
        <ng-container *ngIf="delivery.code === deliveryMethod.pocztaPolskaOrlenZabka">
          <v-cart-poczta-polska (defineNewPoint)="triggerPPWidget(delivery.code, PPWidgetTypes.orlen)" [error]="postOrlenZabkaError" [point]="selectedPP" [selectedPPType]="selectedPPType" [PPType]="delivery.code" [hidden]="selectedDelivery !== deliveryMethod.pocztaPolskaOrlenZabka"></v-cart-poczta-polska>
        </ng-container>
        <ng-container *ngIf="delivery.code === deliveryMethod.pocztaPolskaOthers">
          <v-cart-poczta-polska (defineNewPoint)="triggerPPWidget(delivery.code, PPWidgetTypes.others)" [error]="postOthersError" [point]="selectedOtherPP" [selectedPPType]="selectedPPType" [PPType]="delivery.code" [hidden]="selectedDelivery !== deliveryMethod.pocztaPolskaOthers"></v-cart-poczta-polska>
        </ng-container>
        <ng-container *ngIf="delivery.code === deliveryMethod.dpdPickup">
          <v-cart-dpd  [hidden]="selectedDelivery !== deliveryMethod.dpdPickup" [widget]="runDPD" [error]="dpdPickupError" (defineDPDPoint)="setDPDPoint($event)" (defineDPDPointCode)="setDPDPointCode($event)" [point]="selectedDPDPickup"></v-cart-dpd>
        </ng-container>
      </li>
    </ul>
    <p class="cartDeliveryPayment_cell_error" *ngIf="deliveryError" scroll-to="cartDeliveryPayment_delivery">
      {{"cart.delivery.error.text" | translate}}
    </p>
    <p class="cartDeliveryPayment_cell_info" *ngIf="asmMode === 'true'">
      <b>{{"cart.giftcard.title.text" | translate}}</b>
      <span [innerHTML]="'cart.giftcard.description.text'|translate"></span>
    </p>
  </section>
  <section class="cartDeliveryPayment_cell cartDeliveryPayment_payment" #cartPayment>
    <h3 class="cartDeliveryPayment_cell_title">{{"cart.payment.title.text" | translate}}</h3>
    <ul class="cartDeliveryPayment_cell_list" *ngIf="payments$|async as payments">
      <li class="methodElement methodElement-{{payment.code}}" *ngFor="let payment of payments"
          [ngClass]="{'methodElement-selected': selectedPayment === payment.code && payment.enabled, 'methodElement-disabled': !payment.enabled || paymentSubmitted}">
        <div class="engi-radio-wrapper">
          <input type="radio" name="paymentsModes" [checked]="selectedPayment === payment.code" id="{{payment.code}}" [disabled]="!payment.enabled || paymentSubmitted">
          <label for="{{payment.code}}" (click)="choosePayment(payment.code, payment.enabled)">
            <figure class="methodElement_figure">
              <figcaption>{{payment.code}}</figcaption>
            </figure>
            <p class="methodElement_description">
              <b class="methodElement_description_name">{{payment.name}}</b>
              <span *ngIf="payment.code !== 'payu_installment'">{{payment.description}}</span> <v-cart-installment *ngIf="payment.code === 'payu_installment' && payuInstallmentWidget" [installment]="payment.installment"></v-cart-installment>
            </p>
            <p class="methodElement_description-mobile">
              {{payment.description}}
            </p>
          </label>
        </div>
      </li>
    </ul>
    <p class="cartDeliveryPayment_cell_error" *ngIf="paymentError" scroll-to="cartDeliveryPayment_payment">
      {{"cart.payment.error.text" | translate}}
    </p>
    <p class="cartDeliveryPayment_cell_info">
      <b>{{"cart.giftcard.title.text" | translate}}</b>
      <span [innerHTML]="'cart.giftcard.description.text'|translate"></span>
    </p>
  </section>
</section>
